import _ from 'lodash';
import React from 'react';
import Helmet from 'react-helmet';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

interface BasicRouteProps {
  title?: string;
  children?: React.ReactChild | React.ReactNode | React.ElementType;
}

const BasicRoute = ({ path, ...props }: RouteProps & BasicRouteProps) => {
  const PUBLIC_PATH = process.env.PUBLIC_PATH || '';
  const basePath = PUBLIC_PATH && location.pathname.startsWith(PUBLIC_PATH) ? '' : PUBLIC_PATH;

  const { component: Component, title, render, children, ...rest } = props;

  return (
    <Route
      {...rest}
      path={`${basePath}${path}`}
      render={(componentProps: RouteComponentProps) => {
        const mainBody = _.isFunction(render) ? (
          render(componentProps)
        ) : (
          <Component {...componentProps}>
            {_.isFunction(children) ? children(componentProps) : children}
          </Component>
        );

        return (
          <>
            <Helmet>
              <title>{title}</title>
            </Helmet>
            {mainBody}
          </>
        );
      }}
    />
  );
};

export default BasicRoute;
